module.exports = __webpack_public_path__ + "static/media/light-theme-engineover-duration.883334bc.svg";